module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('v-card-title', [_c('h4', {
    staticClass: "headline ma-0 grey--text text--darken-2"
  }, [_vm._v("Fehlerübersicht")])]), _vm._v(" "), _c('v-list', [_c('v-list-tile', {
    on: {
      "click": function($event) {
        _vm.preFilterFirmen(_vm.err.firmen_marken)
      }
    }
  }, [_c('v-list-tile-content', [_c('v-badge', [_c('span', {
    attrs: {
      "slot": "badge"
    },
    slot: "badge"
  }, [_vm._v(_vm._s(_vm.err.firmen_marken.length))]), _vm._v(" "), _c('span', [_vm._v("Firmen ohne Marken")])])], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    on: {
      "click": function($event) {
        _vm.preFilterFirmen(_vm.err.firmen_adressen)
      }
    }
  }, [_c('v-list-tile-content', [_c('v-badge', [_c('span', {
    attrs: {
      "slot": "badge"
    },
    slot: "badge"
  }, [_vm._v(_vm._s(_vm.err.firmen_adressen.length))]), _vm._v(" "), _c('span', [_vm._v("Firmen ohne Adressen")])])], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    on: {
      "click": function($event) {
        _vm.preFilterFirmen(_vm.err.firmen_created)
      }
    }
  }, [_c('v-list-tile-content', [_c('v-badge', [_c('span', {
    attrs: {
      "slot": "badge"
    },
    slot: "badge"
  }, [_vm._v(_vm._s(_vm.err.firmen_created.length))]), _vm._v(" "), _c('span', [_vm._v("Firmen ohne Created Datum")])])], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    on: {
      "click": function($event) {
        _vm.preFilterFirmen(_vm.err.firmen_updated)
      }
    }
  }, [_c('v-list-tile-content', [_c('v-badge', [_c('span', {
    attrs: {
      "slot": "badge"
    },
    slot: "badge"
  }, [_vm._v(_vm._s(_vm.err.firmen_updated.length))]), _vm._v(" "), _c('span', [_vm._v("Firmen ohne Updated Datum")])])], 1)], 1), _vm._v(" "), _c('v-divider', {
    staticClass: "my-2"
  }), _vm._v(" "), _c('v-list-tile', {
    on: {
      "click": function($event) {
        _vm.preFilterMarken(_vm.err.marken_firmen)
      }
    }
  }, [_c('v-list-tile-content', [_c('v-badge', [_c('span', {
    attrs: {
      "slot": "badge"
    },
    slot: "badge"
  }, [_vm._v(_vm._s(_vm.err.marken_firmen.length))]), _vm._v(" "), _c('span', [_vm._v("Marken ohne Firmen")])])], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    on: {
      "click": function($event) {
        _vm.preFilterMarken(_vm.err.marken_types)
      }
    }
  }, [_c('v-list-tile-content', [_c('v-badge', [_c('span', {
    attrs: {
      "slot": "badge"
    },
    slot: "badge"
  }, [_vm._v(_vm._s(_vm.err.marken_types.length))]), _vm._v(" "), _c('span', [_vm._v("Marken ohne Typen")])])], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    on: {
      "click": function($event) {
        _vm.preFilterMarken(_vm.err.marken_warengruppen)
      }
    }
  }, [_c('v-list-tile-content', [_c('v-badge', [_c('span', {
    attrs: {
      "slot": "badge"
    },
    slot: "badge"
  }, [_vm._v(_vm._s(_vm.err.marken_warengruppen.length))]), _vm._v(" "), _c('span', [_vm._v("Marken ohne Warenguppen")])])], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    on: {
      "click": function($event) {
        _vm.preFilterMarken(_vm.err.marken_logos)
      }
    }
  }, [_c('v-list-tile-content', [_c('v-badge', [_c('span', {
    attrs: {
      "slot": "badge"
    },
    slot: "badge"
  }, [_vm._v(_vm._s(_vm.err.marken_logos.length))]), _vm._v(" "), _c('span', [_vm._v("Marken ohne Logos")])])], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    on: {
      "click": function($event) {
        _vm.preFilterMarken(_vm.err.marken_created)
      }
    }
  }, [_c('v-list-tile-content', [_c('v-badge', [_c('span', {
    attrs: {
      "slot": "badge"
    },
    slot: "badge"
  }, [_vm._v(_vm._s(_vm.err.marken_created.length))]), _vm._v(" "), _c('span', [_vm._v("Marken ohne Created Datum")])])], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    on: {
      "click": function($event) {
        _vm.preFilterMarken(_vm.err.marken_updated)
      }
    }
  }, [_c('v-list-tile-content', [_c('v-badge', [_c('span', {
    attrs: {
      "slot": "badge"
    },
    slot: "badge"
  }, [_vm._v(_vm._s(_vm.err.marken_updated.length))]), _vm._v(" "), _c('span', [_vm._v("Marken ohne Updated Datum")])])], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    on: {
      "click": function($event) {
        _vm.preFilterMarken(_vm.err.marken_dummylogo)
      }
    }
  }, [_c('v-list-tile-content', [_c('v-badge', [_c('span', {
    attrs: {
      "slot": "badge"
    },
    slot: "badge"
  }, [_vm._v(_vm._s(_vm.err.marken_dummylogo.length))]), _vm._v(" "), _c('span', [_vm._v("Marken mit Dummy Logo")])])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-272e30e8","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/errorCard.vue
// module id = 312
// module chunks = 0